import { ActionModal } from '../../../../shared';
import { Text } from '@gravity-ui/uikit';
import { useAuth } from '../../../../entities';

interface LogoutFormProps { 
    isOpen: boolean;
    setOpen: (open: boolean) => void;
}

export const LogoutForm = ({isOpen, setOpen}: LogoutFormProps) => {
    const {logout} = useAuth();

    const handleLogout = async () => {    
        try {
            await logout();
            window.location.reload();
            setTimeout(() => {
                setOpen(false);
            }, 3000);
        } catch (error) {
            window.location.reload();
            console.error('Ошибка при логауте:', error);
            setOpen(false);
        }
    }

  return <ActionModal
  open={isOpen}
  onClose={() => setOpen(false)}
  setOpen={() => setOpen(false)}
  submitForm={handleLogout}
  isLoading={false}
  size={'s'}
  buttonsSize={'l'}
  caption={'Выход'}
  viewActionButton="outlined-danger"
  textButtonApply={'Выйти'}
  textButtonCancel={'Отменить'}>
  <Text color="secondary" variant={'body-2'}>Выйти из своей учетной записи?</Text>
</ActionModal>
};
